// extracted by mini-css-extract-plugin
export default {"window-body":"app_window-body__Zmw0H","main-body-row":"app_main-body-row__gJpgC","container":"app_container__KI7PB"};